import request from "superagent";
import { getAuthHeader } from "../utils/superagent";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'shiftId' implicitly has an 'any' type.
export const createEvent = async (shiftId, event) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .post(`${global.api}/event/create`)
      .set(await getAuthHeader())
      .send({
        shift: shiftId,
        event,
      })
  );
};
